goog.provide('el8.ptdata.model.note.nonvisit');

goog.require('el8.data.nonvisitNoteTypes');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.note.base');
goog.require('el8.ptdata.model.note.muInfo');
goog.require('el8.ptdata.model.note.nonvisitBulletSet');
goog.require('el8.ptdata.vitalsCollections');
goog.require('el8.service.tz');
goog.require('el8.template.ptdata.model.note');


// -----------------
// * NONVISIT NOTE *
// -----------------
(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.ptdata.model.note.base);

    _class.addProperty("bulletSet");
    _class.addProperty("ownedDocuments", true, []);
    _class.addProperty('associatedDocuments', true, []);
    _class.addProperty('vitalsCollections', true, []);
    _class.addProperty('documentType', true, []);
    _class.addModelProperty("meaningfulUseInfo", el8.ptdata.model.note.muInfo, true);

    // only relevant for nonvisit note created from imported email
    _class.addProperty('associatedEmail');
    _class.addProperty('associatedXmlSummary');
    _class.addStringProperty('ccdaContentFileName');

    // only relevant for imported notes
    _class.addIntProperty('originalAuthorUserId');

    _class.prototype.populate = function(spec) {

        spec = spec || {};
        if (spec.type) {
            spec.noteTypeId = spec.type.id;
            el8.data.nonvisitNoteTypes.create(spec.type);
        }

        var vcs = spec['vitals_collections'] || spec['vitalsCollections'];
        el8.ptdata.vitalsCollections.create(vcs);
        spec.vitalsCollections = _.pluck(vcs, 'id');

        this.parent.populate.call(this, spec);

        this.setBulletSet(
            el8.ptdata.model.note.nonvisitBulletSet({noteId: this.getId()}, spec['bullets'])
        );
    };

    _class.prototype.getNoteTypeName = function() {
        var noteType = el8.data.nonvisitNoteTypes.getById(this.getNoteTypeId());
        return noteType.getDisplayName();
    };


    // we just store the IDs but want to return objects
    _class.prototype.getVitalsCollectionObjects = function() {
        return this.getVitalsCollections().map(function(vcId) {
            return el8.ptdata.vitalsCollections.getById(vcId);
        });
    };

    _class.prototype.saveType = function(typeId) {
        if (typeId) { this.setNoteTypeId(typeId); }
        if (this.getNoteTypeId()) {
            var r = {'type': this.getNoteTypeId()};
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+this.getId()+'/type/',
                data: {'data': JSON.stringify(r)}
            });
        }
    };

    _class.prototype.saveDocumentDate = function(aDate, async, successCb) {
        if (aDate) {
            this.setDocumentDate(el8.service.tz.newTzDateTime(aDate));
        }
        if (this.getDocumentDate()) {
            var r = {'document_date': el8.service.tz.asServerFormatDateTime(this.getDocumentDate())};
            $.el8_ajax({
                type: 'POST',
                async: async,
                url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+this.getId()+'/time/',
                data: {data: JSON.stringify(r)},
                success: successCb
            });
        }
    };

    _class.prototype.associateDoc = function(docId, labResultId, successCb) {
        /* There is a function that mimics this exact one in appchart/nonvisitNote/main.js.
         * Be aware when making changes here that they likely need to be made there too */
        var doc = el8.ptdata.fetch({ fetchIds: docId, patientId: this.getPatientId() });
        var data = {'summary': doc.getNoteSummary()};
        if (labResultId) {
            data['lab_result_id'] = labResultId;
        }
        $.el8_ajax({
            type: 'POST',
            url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+this.getId()+'/referenced_docs/'+docId+'/',
            data: {'data': JSON.stringify(data)},
            success: successCb
        });
    };

    _class.prototype.unassociateDoc = function(docId, successCb) {
        $.el8_ajax({
            type: 'DELETE',
            url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+this.getId()+'/referenced_docs/'+docId+'/',
            success: successCb
        });
    };

    _class.prototype.associateItem = function(itemId, successCb) {
        $.el8_ajax({
            type: 'POST',
            url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+this.getId()+'/referenced_items/'+itemId+'/',
            success: successCb
        });
    };

    _class.prototype.addOwnedDocument = function(doc) {
        if (!doc) { return; }
        var current = this.getOwnedDocuments();
        var data = doc.getNoteOwnedDocSummary(true);
        var newNoteDoc = {
            'model_class': doc.getModelClass(),
            'document_id': doc.getId(),
            'summary': data['summary'],
            'summary_formatting': data['summary_formatting']
        };
        current.push(newNoteDoc);
        this.setOwnedDocuments(current);
        $.el8_ajax({
            url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+this.getId()+'/owns_order/'+doc.getId()+'/',
            data: {'data': JSON.stringify(data)},
            type: 'POST',
            success: function() {
                el8.appchart.mainFeeds.chart.update();
            }
        });
        return newNoteDoc;
    };

    _class.prototype.removeOwnedDocument = function(doc) {
        if (!doc) { return; }
        var current = this.getOwnedDocuments();
        var newSet = [];
        for (var i=0; i<current.length; i++) {
            if (current[i].document_id !== doc.getId()) {
                newSet.push(current[i]);
            }
        }
        this.setOwnedDocuments(newSet);
        // Currently we don't need to hit server because server
        // is telling us to do it
        return this;
    };

    _class.prototype.getDescription = function() {

        var noteType = el8.data.nonvisitNoteTypes.getByKey(this.getNoteTypeId());

        if (this.isImportedNote()) {
            var originalAuthor = el8.data.referencedUsers.getById(this.getOriginalAuthorUserId());
            return el8.template.ptdata.model.note.importedNonvisitDescription({
                type: noteType ? noteType.asSoyMap() : '',
                originalAuthorUserName: originalAuthor ? originalAuthor.getFullName() : null,
                documentDate: el8.service.tz.soyStr(this.getDocumentDate())
            }).el8_unescape();

        } else {
            var prefix = this.getSignDate() ? '' : 'Unsigned ';
            return prefix + noteType.getDisplayName() + ' Note';
        }
    };

    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.model.note.nonvisitNoteSummary({
            documentDate: el8.service.tz.soyStr(this.getDocumentDate())
        }).el8_unescape();
    };

    _class.prototype.getNotifyText = function( type ) {
       if( type === 'SAVE_IN_PROGRESS' ) {
            if( this.isOnHold() ) {
                return 'Placing note on hold...';
            } else {
                return 'Saving note...';
            }
        } else if( type === 'SAVE_COMPLETE' ) {
            if( this.isOnHold() ) {
                return 'Nonvisit note placed on hold.';
            } else {
                return 'Nonvisit note filed in chart.';
            }
        } else if( type === 'DELETE_IN_PROGRESS' ) {
            return 'Discarding nonvisit note...';
        } else if( type === 'DELETE_COMPLETE' ) {
            return 'Nonvisit note discarded.';
        } else if( type === 'ADD_TO_NOTE' ) {
            return 'Nonvisit note added to current note.';
        }
    };

    _class.prototype.isTypeDirect = function() {
        var noteType = el8.data.nonvisitNoteTypes.getByKey(this.getNoteTypeId()).getName();
        return (noteType.toUpperCase() === 'DIRECT');
    }

    // ===================================
    // Meaningful use info related methods
    // ====================================
    el8.ptdata.model.note.addMuInfoMethods(_class);
    _class.prototype.updateMeaningfulUseInfo = function(_data) {
        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('documentMeaningfulUse', [this.getId()]),
            data: {data: JSON.stringify(_data)},
            success: function(resp) {
                that.setMeaningfulUseInfoFromSpec(resp);
            }
        });
    };

    el8.ptdata.model.note.nonvisit = function(spec) {
        spec.model_class = 'NonvisitNote';
        return new _class(spec);
    };
})();

